import { render, staticRenderFns } from "./modal-approval-credit-note.vue?vue&type=template&id=4f72c054&"
import script from "./modal-approval-credit-note.vue?vue&type=script&lang=js&"
export * from "./modal-approval-credit-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports